import {
  Box,
  Skeleton,
  Stack,
  Typography,
} from '@ace-clublabs/shared-component-library';

import useAppointmentStore, {
  isInBranchAppointment as isInBranchAppointmentSelector,
} from '@/store/AppointmentStore';
import type { AgentInfo } from '../../utils/AgentInfo';
import AgentsSelection from '../AgentsSelection';

interface AgentSelectionModuleProps {
  matchingAgents: AgentInfo[];
  isLoading?: boolean;
}

const AgentSelectionModule: React.FC<AgentSelectionModuleProps> = ({
  matchingAgents,
  isLoading = false,
}) => {
  const selectedBranch = useAppointmentStore((state) => state.selectedBranch);
  const selectedAgent = useAppointmentStore((state) => state.selectedAgent);
  const setSelectedAgent = useAppointmentStore(
    (state) => state.setSelectedAgent,
  );
  const isInBranchAppointment = useAppointmentStore(
    isInBranchAppointmentSelector,
  );

  if (
    (isInBranchAppointment && !selectedBranch) ||
    (matchingAgents.length === 0 && !isLoading)
  ) {
    return null;
  }

  return (
    <Stack direction='column' sx={{ width: '100%', height: '100%', pt: 1 }}>
      <Box sx={{ px: 2 }}>
        {isLoading ? (
          <Skeleton variant='rounded' width={300} height={35} />
        ) : (
          <Typography variant='h6' sx={{ textAlign: 'left' }}>
            Please select an advisor below
          </Typography>
        )}
      </Box>

      <AgentsSelection
        agents={matchingAgents}
        selectedAgent={selectedAgent}
        onSelectAgent={setSelectedAgent}
        isLoading={isLoading}
      />
    </Stack>
  );
};

export default AgentSelectionModule;
